import { Box, Grid, Table, TableContainer } from "@mui/material";
import { useState } from "react";
import { connect } from "react-redux";
import { setSnack } from "../../models/application/applicationActions";
import { taskService } from "../../models/Task/service";
import { Task } from "../../models/Task/Task";
import TasksFormDialog from "../Dialogs/TasksFormDialog";
import MainTableHeaderBodyContainer from "../MainTableHeaderBodyContainer";

const TasksTable = (props: any) => {
  const { setSnack, app, tableName, handleSubmit, tableList, handleOrder, handleOnToggle, handleOnChange, selectedFilters, filterItems, tableStructureList } =
    props;

  const localList = JSON.parse(localStorage.getItem(tableName) || "{}");
  const [cachedList, setCachedList] = useState<{ key: string; list: any[] }>({ key: "", list: [] });
  const [task, setTask] = useState<Task | null>(null);
  const [open, setOpen] = useState(false);
  const [filteredList, setFilteredList] = useState<any[]>(Object.keys(localList).length ? localList : tableStructureList);

  const onAlert = (text: string) => setSnack({ ...app.snack, open: true, text: text });

  const getOverallTrueFalseFromFilteredList = () => {
    return filteredList.filter((e) => e.enabled === true).length ? true : false;
  };

  const handleCachedList = (item: { key: string; list: any[] }) => {
    setCachedList(item);
  };

  const handleEdit = (state: boolean, item: any) => {
    setOpen(state);
    setTask(item);
  };

  const handleFilteredList = (state: any[]) => {
    setFilteredList(state);
  };

  return (
    <Grid item overflow={"overlay"}>
      <TableContainer>
        <Table sx={{ width: getOverallTrueFalseFromFilteredList() ? "100%" : "fit-content" }}>
          <MainTableHeaderBodyContainer
            padding="checkbox"
            size="small"
            align="center"
            handleEdit={handleEdit}
            filterItems={filterItems}
            headerList={filteredList}
            handleOrder={handleOrder}
            handleOnToggle={handleOnToggle}
            handleCachedList={handleCachedList}
            handleOnChange={handleOnChange}
            selectedFilters={selectedFilters}
            cachedList={cachedList}
            handleFilteredList={handleFilteredList}
            handleSubmit={handleSubmit}
            updater={new Task()}
            service={taskService}
            copySuccessMessage={"Id copied successfully"}
            tableList={tableList}
            tableName={tableName}
            pathname={`taskDetails`}
          />
        </Table>
      </TableContainer>
      <TasksFormDialog setSubmitted={handleSubmit} onAlert={onAlert} item={task!} open={open} app={app} handleDialog={(bool: any) => setOpen(bool)} />
    </Grid>
  );
};

const mapStateToProps = (state: any) => {
  return {
    auth: state.auth,
    app: state.app,
    palette: state.theme.palette,
    muiTheme: state.theme.muiTheme,
  };
};

export default connect(mapStateToProps, { setSnack })(TasksTable);
